module.exports = __webpack_public_path__ + "static/media/EditIcon_Disabled_01.f1ac217d.svg";